import { Component, OnInit } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Router,NavigationEnd  } from '@angular/router';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {

  selectedApp: string | null = null;
  currentUrl: string = '';
  constructor(public router: Router,
    private filterService: FilterService,) { }

  ngOnInit() {
    this.selectedApp = localStorage.getItem('selectedApp');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
      }
    });
  }

  analyticsPage(){
    this.filterService.analyticsSubject.next(true); 
    // this.router.navigate([`analytics`]);
  }
  selectAppPage() {
    this.router.navigate(['/auth/selectapp']);
  }
 nominationsPage(){
    this.filterService.nominationsSubject.next(true); 
    // this.router.navigate([`analytics`]);
  }
  
  toggleDiv() {   
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('toggle-left-menu');
   }

    countSubstring(substring: string): number {
    return (this.currentUrl.match(new RegExp(substring, 'g')) || []).length;
  }

  hasMultipleOccurrences(substring: string, minCount: number): boolean {
    return this.countSubstring(substring) >= minCount;
  }
}
